import { requestBuilder } from '../../http/RequestBuilder';
import type { UpsertUserAddressBody, UserAddress } from '../types/User';

const useUpsertAddress = requestBuilder.mutation<
    UserAddress,
    UpsertUserAddressBody
>({
    endpoint: '/api/address',
    method: 'POST',
});

export default useUpsertAddress;
